import type { FC, ReactNode } from 'react'
import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { useDispatch } from 'react-redux'

import { toggleUpgradeForm } from '@homeviews/store'

import type { ITheme } from '@homeviews/styles'
import Typography from '../Typography'
import Button from '../Button'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      '& .l-lockedContent__title': {
        marginRight: 10,
      },
      '& .l-lockedContent__extraInfo': {
        alignSelf: 'center',
        marginRight: 10,
      },
      '& .l-contentContent__actionButton': {
        marginTop: 3,
      },
      '& .MuiButtonBase-root': {
        width: 'auto',
      },
    },
    locked: {
      '& .l-lockedContent__title': {
        position: 'relative',
        paddingLeft: 20,
        marginBottom: 5,
        marginTop: 5,
        '&:before': {
          content: '""',
          backgroundImage: 'url("assets/icons/locked.svg")',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 14,
          position: 'absolute',
          top: 2.5,
          left: 0,
          width: 16,
          height: 16,
        },
      },
    },
    ctaWrapper: {
      display: 'flex',
      alignItems: 'flex-start',
      marginTop: 5,
    },
    ctaText: {
      color: theme.colors.grey600,
      marginRight: 8,
      marginTop: 3,
    },
    childWrapper: {
      display: 'flex',
      alignItems: 'center',
      marginRight: 'auto',
      paddingRight: 20,
    },
  }),
)

interface IProps {
  children?: ReactNode
  className?: string
  ctaText?: string
  ctaButtonText?: string
  ctaUrl?: string
  isLocked?: boolean
}

const LockedContentHeader: FC<IProps> = ({
  children,
  className,
  ctaText = 'Upgrade your account to access this feature',
  ctaButtonText = 'Upgrade now',
  isLocked,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  return (
    <div className={clsx(classes.root, isLocked && classes.locked, className)}>
      <div className={classes.childWrapper}>{children}</div>
      <div className={classes.ctaWrapper}>
        {isLocked && (
          <Typography className={classes.ctaText}>{ctaText}</Typography>
        )}
        {isLocked && (
          <Button
            variant="contained"
            color="primary"
            customColor="containedGold"
            size="small"
            onClick={() => dispatch(toggleUpgradeForm({ open: true }))}
          >
            {ctaButtonText}
          </Button>
        )}
      </div>
    </div>
  )
}

export default LockedContentHeader
